import moment from 'moment'
import { checkTimeInsidePlayday, checkScheduleType, vehicleLevelFilter } from 'helpers/schedule'
import { UNIT_TYPES } from 'constants'

export function getLastHour(scheduleItems, unitType, vehicleLevel) {
    const periods = getFlatPrimetimes(scheduleItems, unitType, vehicleLevel)

    return Math.max(...periods.map(period => period[1]))
}

export function getFlatPrimetimes(scheduleItems, unitType, vehicleLevel) {
    const selectedScheduleItem = scheduleItems.find(item => (
        item.type === unitType &&
        (!vehicleLevel || item.vehicle_level === vehicleLevel)
    ))

    if (!selectedScheduleItem) return []

    return selectedScheduleItem
        .schedules
        .filter(periphery => periphery.enabled === true)
        .map(per => per.periods)
        .reduce((flatList, primeItem) => flatList.concat(primeItem), [])
}

export const checkEnabledBattles = (scheduleItems, unitType, vehicleLevel) => (
    scheduleItems
        .filter(item => vehicleLevelFilter(item, vehicleLevel))
        .filter(item => item.schedules.some(schedule => schedule.enabled && schedule.periods.length))
        .some(item => checkScheduleType(item, unitType))
)

export function getCurrentPlayday(playdays, vehicleLevel, unitType) {
    const unitTypes = unitType ? [unitType] : [UNIT_TYPES.SORTIE, UNIT_TYPES.FORT_BATTLE]
    const [ today, tomorrow ] = playdays

    const isInsidePlayday = unitTypes
        .map(unitType => getLastHour(today.schedule_items, unitType, vehicleLevel))
        .some(lastPrimetimeHour => checkTimeInsidePlayday(moment(), today.date, 0, lastPrimetimeHour + 1))

    const isBattlesAvailableToday = unitTypes
        .some(unitType => checkEnabledBattles(today.schedule_items, unitType, vehicleLevel))

    if (isInsidePlayday && isBattlesAvailableToday) {
        return today
    }

    const isBattlesAvailableTomorrow = unitTypes
        .some(unitType => checkEnabledBattles(tomorrow.schedule_items, unitType, vehicleLevel))

    if (isBattlesAvailableTomorrow){
        return tomorrow
    }

    return null
}



// WEBPACK FOOTER //
// ./containers/BattleRooms/components/BattleRoomsSchedule/helpers.js